import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { access } from './schemas/common.js';
import { overviewSchema, sourceHealthRowSchema } from './schemas/operations.js';
const c = initContract();
export const overviewContract = c.router({
    summary: {
        method: 'GET',
        metadata: access('viewer'),
        path: '/overview',
        summary: 'Sources, users, retrievals, blocked senders, uptime and what needs attention',
        responses: { 200: overviewSchema },
    },
});
/** Guarded, unlike `health.check`: it names every source and its last error. */
export const healthSourcesContract = c.router({
    sources: {
        method: 'GET',
        metadata: access('viewer'),
        path: '/health/sources',
        summary: 'Every configured source: status, last sync, latency and p95 over 24 hours',
        responses: { 200: z.object({ sources: z.array(sourceHealthRowSchema) }) },
    },
});
//# sourceMappingURL=overview.contract.js.map